<template>
    <div class="login">
        <p class="title">靈九道壇·後台管理系統</p>
        <div class="box">
            <a-input @keyup.enter="login" size="large" placeholder="請輸入賬號" v-model="userName">
                <a-icon slot="prefix" type="user" />
            </a-input>
            <a-input @keyup.enter="login" size="large" type="password" class="pass" placeholder="請輸入密碼" v-model="passWord">
                <a-icon slot="prefix" type="lock" />
            </a-input>
            <a-button class="btn" @click="login" :loading="loading" type="primary" size="large">登錄</a-button>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                userName:'',
                passWord:'',
                loading:false
            }
        },
        methods: {
            login(){
                let self=this;
                if(this.userName===''){
                    this.$Message.warning('请输入用户名')
                    return false;
                }
                if(this.passWord===''){
                    this.$Message.warning('请输入密码')
                    return false;
                }
                this.loading=true;
                this.$http({
                    method: 'post',
                    url: '/manager/admin/login',
                    data:{
                        account:self.userName,
                        password:self.passWord
                    }
                }).then(function(res){
                    if(res.data.code===20000){}else{
                        localStorage.setItem('userInfo',JSON.stringify(res.data))
                        localStorage.setItem('token',res.data.token)
                        self.$Message.success('登陆成功')
                        self.$router.replace({name:'home'})
                    }
                    self.loading=false;
                }).catch(err=>{
                    self.loading=false;
                })
            }
        },
        created() {
        },
    }
</script>
<style lang="less">
    div.login{
        width:100%;
        height:100%;
        position: fixed;
        left:0;
        top:0;
        background-image: url(../assets/image/back.jpg);
        background-repeat: no-repeat;
        background-position:center;
        background-size:auto 100%;
        display: flex;
        align-items: center; /*定义body的元素垂直居中*/
        justify-content: center; /*定义body的里的元素水平居中*/
        div.box{
            width:460px;
            height:260px;
            background-size: 100% 100%;
            border-radius: 6px;
            background-image: url(../assets/image/login.jpg);
            box-shadow: #e8b827 2px 2px 8px;
            padding:40px 20px;
            .btn{
                width:360px;
                margin-top:40px;
            }
            .pass{
                margin-top:20px;
            }
        }
        p.title{
            position: absolute;
            width:100%;
            top:180px;
            text-align: center;
            font-size: 30px;
            color:#fff;
        }
        .ant-input-affix-wrapper-lg{
            width:360px;
        }
        .ant-input{
            background: transparent;
        }
    }
</style>